import {Pipe, PipeTransform} from '@angular/core';
import {NgbDate} from "@ng-bootstrap/ng-bootstrap";
import {TranslocoService} from "@ngneat/transloco";

@Pipe({
    name: 'dateRangePipe',
    standalone: false
})
export class DateRangePipe implements PipeTransform {

    constructor(private translocoService: TranslocoService, ) {
    }

    transform(dateFrom: NgbDate | undefined, dateTo: NgbDate | undefined): string {
        if (dateFrom) {
            if (dateTo) {
                if (dateTo.month === dateFrom.month && dateTo.year === dateFrom.year) {
                    return `${this.translocoService.translate('months.picker.short.' + (dateFrom.month))} ${dateFrom.year}`
                }
                if (dateFrom.month !== dateTo.month && dateTo.year === dateFrom.year) {
                    return `${this.translocoService.translate('months.picker.short.' + (dateFrom.month))} -
                    ${this.translocoService.translate('months.picker.short.' + (dateTo.month))} 
                    ${dateTo.year}`
                }
                else {
                    return `${this.translocoService.translate('months.picker.short.' + (dateFrom.month))} ${dateFrom.year}-
                    ${this.translocoService.translate('months.picker.short.' + (dateTo.month))} 
                    ${dateTo.year}`
                }
            }
            else {
                return this.translocoService.translate('months.picker.short.' + (dateFrom.month)) + ' ' + dateFrom.year;
            }
        }
        else if (dateTo){
            return this.translocoService.translate('months.picker.short.' + dateTo.month) + ' ' + dateTo.year;
        }
        else return "";
    }
}
